import { Landscape } from '@/components/generals/landscape'
import { Eyebrow } from '@/components/generals/eyebrow'
import { PillButton } from '@/components/generals/pill-button'
import { Reveal } from '@/components/generals/reveal'
import { SplitHeading } from '@/components/generals/split-heading'
import { LANDSCAPES } from '@/lib/visual'

interface CtaBandProps {
    eyebrow?: string
    title?: string
    buttonLabel?: string
    href?: string
    note?: string
    image?: string
    position?: string
}

/** Full-width landscape fading into black, with one clear call to action. */
export const CtaBand = ({
    eyebrow = 'Your next step',
    title = 'A steadier way with money\n*begins here*',
    buttonLabel = 'Begin your free trial',
    href = '/login?mode=signup',
    note = 'No card required. Leave whenever you like.',
    image = LANDSCAPES.windingPath,
    position = 'center 58%'
}: CtaBandProps) => {
    return (
        <section id='get-started' aria-label='Get started' className='relative isolate overflow-hidden bg-black'>
            <div className='absolute inset-0'>
                <Landscape src={image} fade='top-bottom' position={position} />
                <div aria-hidden='true' className='absolute inset-0 bg-[radial-gradient(60%_55%_at_50%_50%,rgba(0,0,0,0.15),rgba(0,0,0,0.65)_100%)]' />
            </div>

            <div className='shell relative z-10 flex min-h-[620px] flex-col items-center justify-center py-32 text-center sm:min-h-[760px]'>
                <Eyebrow>
                    {eyebrow}
                </Eyebrow>

                <SplitHeading
                    text={title}
                    className='mt-7 max-w-4xl text-balance text-[2.6rem] font-normal leading-[1] tracking-[-0.045em] text-cream sm:text-6xl md:text-7xl'
                />

                <Reveal delay={700} className='mt-10'>
                    <PillButton href={href} size='lg'>
                        {buttonLabel}
                    </PillButton>
                </Reveal>

                {note && (
                    <Reveal as='p' delay={900} className='mt-6 text-sm text-cream/55'>
                        {note}
                    </Reveal>
                )}
            </div>
        </section>
    )
}
